'use client';
import GloLayout from 'lowcode/common/GloLayout';
import FullScreenModal from 'lowcomp/plugins/member/common/FullScreenModal';
import RewardsRedeemed from 'lowcomp/plugins/member/common/RewardsRedeemed';
import { useEffect, useState } from 'react';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import { getLang, injectNotes } from '../../utils';
import { textLang } from '../../common/textLang';
import { config } from '../config';
import styles from './index.module.scss';
import LuckyTurntable from './components';
import { LuckyProvider } from './components/LuckyProvider';
import LuckyHistory from './components/History';
import { getIsLogin } from '@/utils/cookie';
import { getIssuedCoupons } from '@/service/vip';
import getLocal from '@/app/utils/getLocal';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { locale } = getLocal();
    const t = getLang(textLang, locale);
    const [isLogin, setIsLogin] = useState(false);
    const [showPage, setShowPage] = useState('basic'); // basic / history_modal / coupon_modal / points_modal / bouns_modal / qhistory_modal / lucky_history
    const [issuedCoupon, setIssuedCoupon] = useState<any[]>([]);
    const { timezoneList } = useMemberTimeStore();

    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);

    const {
        backgroundColor,
        titleColor,
        subTitleColor,
        themeColor,
        showListBtn,
        showRewardsBtn,
        bgImage,
        btnImage,
        prizeFontColor,
        prizeBgColor1,
        prizeBgColor2,
        prizeBgColor3,
        listBtnColor,
        rewardsBtnColor,
        loginType,
    } = data;
    const { defaultData } = config;
    const styleOption: any = {
        '--member-lucky-background': backgroundColor || defaultData.backgroundColor,
        '--member-lucky-title': titleColor || defaultData.titleColor,
        '--member-lucky-subtitle': subTitleColor || defaultData.subTitleColor,
        '--member-lucky-theme': themeColor || defaultData.themeColor,
        '--member-lucky-prizefont': prizeFontColor || defaultData.prizeFontColor,
        '--member-lucky-prizebg1': prizeBgColor1 || defaultData.prizeBgColor1,
        '--member-lucky-prizebg2': prizeBgColor2 || defaultData.prizeBgColor2,
        '--member-lucky-prizebg3': prizeBgColor3 || defaultData.prizeBgColor3,
        '--member-lucky-listbtncolor': listBtnColor || defaultData.listBtnColor,
        '--member-lucky-rewardsbtncolor': rewardsBtnColor || defaultData.rewardsBtnColor,
    };

    /**
     * 查询issued优惠券兑换记录
     */
    const queryIssuedRewards = async () => {
        const res = await getIssuedCoupons(locale);
        if (res?.code === '0') {
            const coupons = injectNotes(res?.data || [], t, locale, timezoneList);
            setIssuedCoupon(coupons || []);
        }
    };

    return (
        <GloLayout id={id} className={`temp-questions ${styles.content}`}>
            <LuckyProvider>
                <div
                    style={styleOption}
                    className="GtmModuleData-section"
                    data-section-id={'Member-LuckyTurntable'}
                    data-section-title={'Member-LuckyTurntable'}
                >
                    <LuckyTurntable
                        id={data.id}
                        isEditStatus={isEditStatus}
                        isLogin={isLogin}
                        loginType={loginType}
                        setShowPage={setShowPage}
                        showListBtn={showListBtn}
                        showRewardsBtn={showRewardsBtn}
                        bgImage={bgImage}
                        btnImage={btnImage}
                    />
                </div>
                {/* 历史弹窗 */}
                {showPage === 'lucky_history' && (
                    <FullScreenModal visible={showPage === 'lucky_history'} className={showPage} closeModal={() => setShowPage('')}>
                        <LuckyHistory showPage={showPage} />
                    </FullScreenModal>
                )}
                {/* 优惠券弹窗 */}
                {showPage?.startsWith('coupon_modal') && (
                    <FullScreenModal
                        visible={showPage?.startsWith('coupon_modal')}
                        className={showPage}
                        style={{ background: '#f8f8f8' }}
                        closeModal={() => setShowPage('')}
                        afterOpen={() => {
                            queryIssuedRewards();
                        }}
                    >
                        <RewardsRedeemed modal defaultSelectKey={(showPage?.includes('$') && showPage?.split('$').pop()) || '1'} issuedCoupon={issuedCoupon} />
                    </FullScreenModal>
                )}
            </LuckyProvider>
        </GloLayout>
    );
}
